<template>
  <div>

   <iframe src="https://docs.google.com/document/d/e/2PACX-1vRZb-ftcsaqRJwLGIWo6traBxOdWlBRRlVoPdUwEPYqvQ4boIjBlPgRnCaEGJHfaem7T1WpLaJ1rm8k/pub?embedded=true" width="100%" height="650px"></iframe>   

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>